import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import locale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './DateDialog.html?raw';
// DOM-heavy calendar builder → dom-construct aliased to any.

const domConstruct: any = domConstructTyped;

class DateDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    multiselect = false;
    selectedDates: any = [];
    selectedMonth: any = undefined;
    showState = false;
    allowPast = true;
    maxValue: any = null;

    _bCloseAfterSelection = true;

    classNameToday = "dateItem_today";
    classNameSelected = "dateItem_selected";
    classNameOthermonth = "dateItem_othermonth";
    classNameWeekend = "dateItem_weekend";

    classNameButton = "dateItem_button";
    classNameDefault = "dateItem_default";

    yearSelect: any = undefined;
    monthSelect: any = undefined;

    constructor(params?: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, params);
    }

    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.dateDialog.nodeList = [];
        this.selectedDates = [];
        this._createCalendar(new Date());
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

    _setCallbackAttr(value: any): void {
        this.callback = value;
    }

    _setCloseAfterSelectAttr(value: any): void {
        this._bCloseAfterSelection = value === true;
    }

    _closeDropwdowns(): void {
        if (this.monthSelect.classList.contains("show")) this.toggleMonthSelect();
        if (this.yearSelect.classList.contains("show")) this.toggleYearSelect();
    }

    _changePage(e: any): void {
        var targ = e.target;
        this._createCalendar(new Date(targ.getAttribute('date')));
    }

    _chooseDate(e: any): void {
        var targ = e.target;
        var d = targ.getAttribute('date');

        if (this.multiselect) {
            if (this.selectedDates[d]) {
                this.removeDate(d);
            } else {
                this.addDate(d);
            }
        } else {
            this.removeSelectedDates();
            this.addDate(d);

            if (this._bCloseAfterSelection == true) {
                this.hide();
            }
        }
    }

    addDate(d: any): void {
        this._closeDropwdowns();
        this.selectedDates[d] = d;
        if (this.dateDialog.nodeList[d]) this.changeItemState(this.dateDialog.nodeList[d], "selected");

        if (typeof this.callback === "function") {
            this.callback("add", d, this.selectedDates);
        }
    }

    removeDate(d: any): void {
        if (this.selectedDates[d]) {
            this._closeDropwdowns();
            delete this.selectedDates[d];
            if (this.dateDialog.nodeList[d]) this.changeItemState(this.dateDialog.nodeList[d]);
        }

        if (typeof this.callback === "function") {
            this.callback("del", d, this.selectedDates);
        }
    }

    _getShortDate(d: any): any {
        return ("0" + d.getDate()).slice(-2) + '.' + ("0" + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
    }

    _getMonth(d: any): any {
        return ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'][d.getMonth()];
    }

    _stringToDate(possibleDate: any): any {
        return locale.parse(possibleDate, {
            locale: "de",
            formatLength: "short",
            selector: "date"
        });
    }

    _createCalendar(month: any): void {

        if (this.allowPast === false && this.selectedMonth != null) {
            if (this.selectedMonth.getTime() > month.getTime()) { // nur beim zurück navigieren
                //console.log(month);
                if (month.getMonth() < (new Date).getMonth() && month.getFullYear() <= (new Date).getFullYear()) {
                    return;
                }
            }
        }

        if (this.maxValue != null) {
            console.log(month, this.maxValue);
            if (month.getTime() > this.maxValue.getTime()) {
                return;
            }
        }

        this.selectedMonth = month;

        var today = new Date();
        var todayShort = this._getShortDate(new Date());
        var date = new Date(month.getFullYear(), month.getMonth(), 1, 0, 0, 0, 0); // Starting at the 1st of the month
        var extras = (date.getDay() + 6) % 7; // How many days of the last month do we need to include?
        date.setDate(date.getDate() - extras); // Skip back to the previous monday

        var table = domConstruct.create("table");
        var tr = domConstruct.create("tr", null, table, "last");

        var td = domConstruct.create("td", null, tr, "last");
        var prevMonth = domConstruct.create("button", {
            //type: "button",
            innerHTML: "<"
        }, td, "last");
        this.changeItemState(prevMonth, "button");
        domAttr.set(prevMonth, "date", new Date(month.getFullYear(), month.getMonth() - 1, 1, 0, 0, 0, 0).toString());
        on(prevMonth, "click", lang.hitch(this, this._changePage));

        var td = domConstruct.create("td", {
            colSpan: 3
        }, tr, "last");
        var mon = domConstruct.create("button", {
            //type: "text",
            readonly: true,
            style: "width: 6em;",
            innerHTML: this._getMonth(month)
        }, td, "last");
        if (month.getMonth() == today.getMonth() && month.getFullYear() == today.getFullYear()) {
            this.changeItemState(mon, "button");
        } else {
            this.changeItemState(mon, "button");
        }
        on(mon, "click", lang.hitch(this, this.toggleMonthSelect));

        this.monthSelect = domConstruct.create("div", {
            style: "position: absolute;background-color: white;display:none;"
        }, td, "last");
        on(this.monthSelect, "click", lang.hitch(this, this._changePage));
        for (var i = 1; i < 13; i++) {
            var newDate = new Date(month.getFullYear(), i, 0, 0, 0, 0);

            var toMonth = domConstruct.create("input", { value: this._getMonth(newDate) }, this.monthSelect, "last");
            domAttr.set(toMonth, "date", newDate.toString());
            if (newDate.getMonth() == today.getMonth() && month.getFullYear() == today.getFullYear()) {
                this.changeItemState(toMonth, "button");
            } else {
                this.changeItemState(toMonth, "button");
            }
        }


        var td = domConstruct.create("td", {
            colSpan: 2
        }, tr, "last");
        var year = domConstruct.create("button", {
            //type: "text",
            readonly: true,
            style: "width: 4em;",
            innerHTML: month.getFullYear()
        }, td, "last");
        if (month.getFullYear() == today.getFullYear()) {
            this.changeItemState(year, "button");
        } else {
            this.changeItemState(year, "button");
        }
        on(year, "click", lang.hitch(this, this.toggleYearSelect));


        this.yearSelect = domConstruct.create("div", {
            style: "position: absolute;background-color: white;display:none;"
        }, td, "last");
        on(this.yearSelect, "click", lang.hitch(this, this._changePage));
        for (var i = -2; i < 3; i++) {
            var newDate = new Date(month.getFullYear() + i, month.getMonth(), 1, 0, 0, 0, 0);
            var toYear = domConstruct.create("input", { value: month.getFullYear() + i }, this.yearSelect, "last");
            domAttr.set(toYear, "date", newDate.toString());
            if (newDate.getFullYear() == today.getFullYear()) {
                this.changeItemState(toYear, "button");
            } else {
                this.changeItemState(toYear, "button");
            }
        }

        var td = domConstruct.create("td", null, tr, "last");
        var nextMonth = domConstruct.create("button", {
            //type: "button",
            innerHTML: ">"
        }, td, "last");
        this.changeItemState(nextMonth, "button");
        domAttr.set(nextMonth, "date", new Date(month.getFullYear(), month.getMonth() + 1, 1, 0, 0, 0, 0).toString());
        on(nextMonth, "click", lang.hitch(this, this._changePage));

        var daysRow = domConstruct.create("tr", null, table, "last");
        var td = domConstruct.create("td", { innerHTML: "Mo", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "Di", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "Mi", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "Do", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "Fr", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "Sa", className: "DateDialogDayHeader" }, daysRow, "last");
        var td = domConstruct.create("td", { innerHTML: "So", className: "DateDialogDayHeader" }, daysRow, "last");

        this.dateDialog.nodeList = [];
        while (1) { // Loop for each week
            var tr = table.insertRow(-1);
            for (var i = 0; i < 7; i++) {
                if (date.getMonth() == month.getMonth()) {
                    var selectable: any = true;
                    if (this.allowPast == false) {
                        if (date.getTime() < (new Date).setHours(0, 0, 0, 0)) {
                            selectable = false;
                        }
                    }

                    var dateShort = this._getShortDate(date);
                    var td = domConstruct.create("td", null, tr, "last");
                    var input = domConstruct.create("input", {
                        style: (selectable == true) ? "cursor: pointer;" : "cursor: not-allowed;",
                        type: "button",
                        value: date.getDate()
                    }, td, "last");
                    this.dateDialog.nodeList[dateShort] = input;
                    this.changeItemState(input);
                    if (selectable == true) {
                        on(input, "click", lang.hitch(this, this._chooseDate));
                    }
                    domAttr.set(input, "date", this._getShortDate(date));

                    if (this.selectedDates[dateShort] == dateShort) {
                        this.changeItemState(input, "selected");
                    }
                    if (date.getMonth() != month.getMonth()) {
                        this.changeItemState(input, "othermonth");
                    }
                    if (todayShort == dateShort) {
                        this.changeItemState(input, "today");
                    }
                    if (i >= 5 && i <= 6) {
                        this.changeItemState(input, "weekend");
                    }
                } else {

                    var selectable: any = false;

                    var dateShort = this._getShortDate(date);
                    var td = domConstruct.create("td", null, tr, "last");
                    var input = domConstruct.create("input", {
                        style: (selectable == true) ? "cursor: pointer;" : "cursor: not-allowed;",
                        type: "button",
                        value: ""
                    }, td, "last");
                    this.dateDialog.nodeList[dateShort] = input;
                    this.changeItemState(input);
                    if (selectable == true) {
                        on(input, "click", lang.hitch(this, this._chooseDate));
                    }
                    domAttr.set(input, "date", this._getShortDate(date));

                    if (this.selectedDates[dateShort] == dateShort) {
                        this.changeItemState(input, "selected");
                    }
                    if (date.getMonth() != month.getMonth()) {
                        this.changeItemState(input, "othermonth");
                    }
                    if (todayShort == dateShort) {
                        this.changeItemState(input, "today");
                    }
                }

                date.setDate(date.getDate() + 1);
            }

            if (date.getMonth() != month.getMonth()) {
                break;
            }
        }
        domConstruct.place(table, this.dateDialog, "only");
    }

    removeSelectedDates(): void {
        for (var d in this.selectedDates) {
            this.removeDate(d);
        }
        this._closeDropwdowns();
        //this.hide();
    }

    toggle(): void {
        if (this.showState) {
            this.hide();
        } else {
            this.show();
        }
    }

    show(): void {
        this.showState = true;
        domStyle.set(this.dateDialog, "display", "block");
    }

    hide(): void {
        this.showState = false;
        domStyle.set(this.dateDialog, "display", "none");
    }

    toggleYearSelect(a?: any, b?: any): void {
        if (this.monthSelect.classList.contains("show")) this.toggleMonthSelect(null, false);
        domClass.toggle(this.yearSelect, "show");
    }

    toggleMonthSelect(a?: any, b?: any): void {
        if (this.yearSelect.classList.contains("show")) this.toggleYearSelect(null, false);
        domClass.toggle(this.monthSelect, "show");
    }

    changeItemState(node: any, newState?: any): void {
        switch (newState) {
            case "today":
                this.setItemState(node, true, null, false, false, null);
                break;
            case "selected":
                this.setItemState(node, null, true, false, false, false);
                break;
            case "othermonth":
                this.setItemState(node, false, null, true, false, null);
                break;
            case "button":
                this.setItemState(node, false, false, false, true, false);
                break;
            case "weekend":
                this.setItemState(node, false, false, false, false, false, true);
                break;
            default:
                this.setItemState(node, null, false, false, false, true);
        }
    }
    setItemState(node: any, isToday: any, isSelected: any, isOthermonth: any, isButton: any, isDefault: any, isWeekend?: any): void {
        if (typeof isToday === 'boolean') domClass.toggle(node, this.classNameToday, isToday);
        if (typeof isSelected === 'boolean') domClass.toggle(node, this.classNameSelected, isSelected);
        if (typeof isOthermonth === 'boolean') domClass.toggle(node, this.classNameOthermonth, isOthermonth);
        if (typeof isButton === 'boolean') domClass.toggle(node, this.classNameButton, isButton);
        if (typeof isDefault === 'boolean') domClass.toggle(node, this.classNameDefault, isDefault);
        if (typeof isWeekend === 'boolean') domClass.toggle(node, this.classNameWeekend, isWeekend);
    }
}
DateDialog.prototype.declaredClass = 'more.DateDialog';

export default mdsWidget(DateDialog);
